export const navLinks = [
  { id: 'categories', label: '栏目总览' },
  { id: 'hot', label: '高能合集' },
  { id: 'gallery', label: '沙雕图集' },
  { id: 'memes', label: '弹幕梗' },
  { id: 'story', label: '关于本站' },
  { id: 'faq', label: '常见问题' },
];

export const heroStats = [
  { value: '326', label: '期恶搞合集' },
  { value: '1800+', label: '张沙雕图' },
  { value: '2100+', label: '条弹幕梗' },
  { value: '12w+', label: '乐子人收藏' },
];

export const categories = [
  {
    icon: 'ri-film-line',
    title: '魔改版解说',
    desc: '把经典名场面重新配音、换字幕、反转剧情，越看越离谱越上头。',
    tag: '每期2更',
  },
  {
    icon: 'ri-speak-line',
    title: '神吐槽合集',
    desc: '一句话点破火影世界那些经不起推敲的设定，弹幕式吐槽直击灵魂。',
    tag: '高频更新',
  },
  {
    icon: 'ri-emotion-laugh-line',
    title: '沙雕图集',
    desc: '灵魂P图、表情包二创、名场面截图，专治各种不开心。',
    tag: '每日上新',
  },
  {
    icon: 'ri-scissors-cut-line',
    title: '恶搞剧情',
    desc: '把剧情魔改成完全不同的走向，全角色OOC预警，笑到停不下来。',
    tag: '周更特辑',
  },
  {
    icon: 'ri-fire-line',
    title: '爆笑名场面',
    desc: '盘点那些一看到就绷不住的经典瞬间，每帧都是行走的表情包。',
    tag: '精选排行',
  },
  {
    icon: 'ri-chat-smile-3-line',
    title: '弹幕梗汇总',
    desc: '把视频里刷屏的弹幕梗整理成册，一句话就能点燃全场气氛。',
    tag: '持续收录',
  },
];

export const hotList = [
  {
    tag: '魔改解说',
    badge: '本周爆款',
    title: '鸣人申请查克拉时考官的表情管理有多失败',
    views: '28.6w',
    likes: '1.2w',
    likesPercent: 96,
    image: 'https://readdy.ai/api/search-image?query=playful%20anime%20comedy%20illustration%20fiery%20orange%20energy%20whirl%20comic%20speed%20lines%20funny%20cartoon%20ninja%20action%20warm%20golden%20tones%20stylized%20humor%20meme%20vibe%20high%20detail&width=800&height=450&seq=hot-0-2026&orientation=landscape',
  },
  {
    tag: '恶搞剧情',
    badge: '离谱反转',
    title: '如果卡卡西迟到理由被写进忍者守则',
    views: '21.3w',
    likes: '9800',
    likesPercent: 93,
    image: 'https://readdy.ai/api/search-image?query=funny%20anime%20manga%20panel%20ninja%20sensei%20late%20for%20work%20cartoon%20comedy%20warm%20orange%20background%20comic%20speech%20bubbles%20stylized%20humor%20playful%20high%20detail&width=800&height=450&seq=hot-1-2026&orientation=landscape',
  },
  {
    tag: '神吐槽',
    badge: '弹幕炸了',
    title: '忍者为什么都不好好走正门，偏要爬房顶',
    views: '17.9w',
    likes: '7600',
    likesPercent: 90,
    image: 'https://readdy.ai/api/search-image?query=anime%20ninja%20rooftops%20village%20climbing%20humorous%20meme%20comic%20style%20warm%20golden%20evening%20sky%20playful%20cartoon%20silhouettes%20stylized%20comedy%20high%20detail&width=800&height=450&seq=hot-2-2026&orientation=landscape',
  },
  {
    tag: '爆笑名场面',
    badge: '经典永流传',
    title: '盘点火影里那些一本正经讲废话的名场面',
    views: '24.1w',
    likes: '1.1w',
    likesPercent: 94,
    image: 'https://readdy.ai/api/search-image?query=vibrant%20anime%20comedy%20collage%20serious%20speech%20with%20absurd%20lines%20comic%20panels%20warm%20orange%20red%20tones%20playful%20meme%20energy%20stylized%20cartoon%20high%20detail&width=800&height=450&seq=hot-3-2026&orientation=landscape',
  },
  {
    tag: '魔改解说',
    badge: '新更',
    title: '大蛇丸的科研经费到底是怎么报账的',
    views: '9.8w',
    likes: '4100',
    likesPercent: 88,
    image: 'https://readdy.ai/api/search-image?query=funny%20anime%20laboratory%20mad%20scientist%20ninja%20accounting%20joke%20comic%20style%20warm%20amber%20tones%20playful%20cartoon%20meme%20stylized%20humor%20high%20detail&width=800&height=450&seq=hot-4-2026&orientation=landscape',
  },
  {
    tag: '弹幕梗',
    badge: '热梗',
    title: '“你还差得远呢”在火影弹幕里的N种用法',
    views: '13.5w',
    likes: '5200',
    likesPercent: 89,
    image: 'https://readdy.ai/api/search-image?query=anime%20danmaku%20comment%20overlay%20comic%20style%20crowd%20of%20floating%20chat%20bubbles%20warm%20orange%20background%20playful%20meme%20cartoon%20stylized%20high%20detail&width=800&height=450&seq=hot-5-2026&orientation=landscape',
  },
];

export const gallery = [
  { ratio: 'tall', caption: '影分身之后，到底哪个才是本体？', image: 'https://readdy.ai/api/search-image?query=playful%20anime%20ninja%20shadow%20clones%20confused%20comic%20meme%20warm%20orange%20tones%20stylized%20cartoon%20humor%20high%20detail&width=600&height=800&seq=gallery-0-2026&orientation=portrait' },
  { ratio: 'tall', caption: '今天的午饭，是螺旋丸味道的。', image: 'https://readdy.ai/api/search-image?query=funny%20anime%20food%20bowl%20noodle%20energy%20spiral%20joke%20comic%20style%20warm%20golden%20tones%20playful%20cartoon%20meme%20high%20detail&width=600&height=800&seq=gallery-1-2026&orientation=portrait' },
  { ratio: 'tall', caption: '忍者考试前夜的复习现场。', image: 'https://readdy.ai/api/search-image?query=anime%20ninja%20student%20late%20night%20study%20desk%20cramming%20comic%20meme%20warm%20lamp%20light%20orange%20tones%20playful%20cartoon%20high%20detail&width=600&height=800&seq=gallery-2-2026&orientation=portrait' },
  { ratio: 'tall', caption: '当查克拉用尽的鸣人看到拉面。', image: 'https://readdy.ai/api/search-image?query=excited%20anime%20boy%20noodle%20ramen%20happy%20energy%20comic%20style%20warm%20orange%20red%20tones%20playful%20cartoon%20meme%20high%20detail&width=600&height=800&seq=gallery-3-2026&orientation=portrait' },
  { ratio: 'tall', caption: '佐助：我只需要变强，和变强。', image: 'https://readdy.ai/api/search-image?query=cool%20brooding%20anime%20ninja%20portrait%20serious%20moody%20comic%20meme%20warm%20amber%20tones%20stylized%20cartoon%20humor%20high%20detail&width=600&height=800&seq=gallery-4-2026&orientation=portrait' },
  { ratio: 'tall', caption: '写轮眼买一送一活动火热进行中。', image: 'https://readdy.ai/api/search-image?query=red%20glowing%20anime%20eyes%20copy%20wheel%20sale%20promo%20joke%20comic%20style%20warm%20red%20orange%20tones%20playful%20cartoon%20meme%20high%20detail&width=600&height=800&seq=gallery-5-2026&orientation=portrait' },
  { ratio: 'tall', caption: '通灵之术失败的尴尬瞬间。', image: 'https://readdy.ai/api/search-image?query=awkward%20anime%20ninja%20summoning%20failed%20smoke%20clumsy%20comic%20meme%20warm%20orange%20tones%20playful%20cartoon%20high%20detail&width=600&height=800&seq=gallery-6-2026&orientation=portrait' },
  { ratio: 'tall', caption: '火影办公室的日常加班图鉴。', image: 'https://readdy.ai/api/search-image?query=tired%20anime%20office%20workers%20overtime%20desk%20stack%20papers%20comic%20meme%20warm%20amber%20tones%20playful%20cartoon%20high%20detail&width=600&height=800&seq=gallery-7-2026&orientation=portrait' },
];

export const danmaku = [
  '“忍者不加班，只有无限续集的意志！”',
  '“写轮眼看多了，连眼神都学会了复制。”',
  '“这套影分身，是我见过最会偷懒的。”',
  '“查克拉不够？没关系，鸣人的嘴遁管够。”',
  '“谁规定忍者必须走门的？影分身直接穿墙。”',
  '“火影世界的物价：一乐拉面永不涨价。”',
  '“结印三十秒，不如摸头杀一秒。”',
  '“这集的内容，全靠弹幕撑起来了。”',
];

export const storyPoints = [
  {
    icon: 'ri-lightbulb-flash-line',
    title: '内容够野',
    desc: '坚持原创恶搞与二创精神，把火影世界观玩出新花样，绝不搬运洗稿。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '坚持原创',
    desc: '所有魔改剧情、吐槽与P图均为原创产出，保护创作者价值。',
  },
  {
    icon: 'ri-group-line',
    title: '乐子人集合',
    desc: '这里是火影爱好者的快乐老家，截图、玩梗、催更，大家一起嗨。',
  },
  {
    icon: 'ri-rocket-2-line',
    title: '持续高能',
    desc: '每天都有新图、新梗、新吐槽，随时打开都有新乐子等着你。',
  },
];

export const testimonials = [
  {
    name: '木叶の咸鱼',
    role: '三好学生·看梗党',
    content: '每次更新都笑到捶桌，火影黄本子的魔改解说是我每天的快乐源泉。',
  },
  {
    name: '螺旋丸批发商',
    role: 'P图十级选手',
    content: '图集质量真的高，张张都是可以直接发群里的灵魂表情包。',
  },
  {
    name: '爱看番的熬夜人',
    role: '弹幕收藏家',
    content: '弹幕梗汇总太懂我们了，一句话就能让我回忆起追番的快乐。',
  },
];

export const faqs = [
  {
    q: '火影黄本子是什么类型的网站？',
    a: '火影黄本子是一个围绕火影题材的恶搞与吐槽内容聚合站，集中发布魔改版解说、神吐槽合集、沙雕图集、爆笑名场面和弹幕梗汇总，主打轻松搞笑、适合截图分享的娱乐内容。',
  },
  {
    q: '内容多久更新一次？',
    a: '沙雕图集与弹幕梗每日上新，魔改解说与神吐槽合集保持高频更新，恶搞剧情特辑每周推出一期，热门高能片段随时加更，基本每天打开都有新内容。',
  },
  {
    q: '可以截图和转发内容吗？',
    a: '当然可以。本站内容本身就是为分享而生的，欢迎截图、转发到社交平台。如需转载到自媒体，请注明来源并保留水印，尊重创作者产出。',
  },
  {
    q: '为什么叫“黄本子”？',
    a: '“黄本子”在这里指代火影题材的同人恶搞内容册，与剧情无关，纯粹是一群乐子人对魔改吐槽内容的亲切称呼，没有任何不良含义。',
  },
  {
    q: '如何投稿自己制作的梗图？',
    a: '如果你也有火影相关的沙雕图、神吐槽或魔改作品，可以通过页面底部的联系方式或订阅表单投稿，审核通过后我们会署名发布。',
  },
  {
    q: '内容是否需要付费？',
    a: '不需要，本站全部内容免费阅读与分享。我们只希望大家玩得开心，也欢迎通过分享让更多乐子人加入这个快乐老家。',
  },
];